/* ============================================================
 * Infoskjerm v2 — animated screen mockup (vanilla JS)
 * Renders 5 cycling layouts (welcome, calendar, menu, weather, news)
 * with live clock + scrolling ticker. Designed to be drop-in: looks
 * for any element with `[data-iv-mockup]` and brings it to life.
 * ============================================================ */
(function () {
  'use strict';

  function fmtTime(d) {
    return d.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit' });
  }
  function fmtMonthYear(d) {
    return d.toLocaleDateString('nb-NO', { month: 'long', year: 'numeric' });
  }

  function el(tag, attrs, children) {
    const node = document.createElement(tag);
    if (attrs) {
      for (const k in attrs) {
        if (k === 'class') node.className = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else node.setAttribute(k, attrs[k]);
      }
    }
    (children || []).forEach(function (c) {
      if (c == null) return;
      node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return node;
  }

  function header(label, time) {
    return el('div', { class: 'iv-mk-header' }, [
      el('div', { class: 'iv-brand' }, [
        el('span', { class: 'iv-brand-dot' }),
        document.createTextNode(' ' + label),
      ]),
      el('div', { class: 'iv-clock' }, [time]),
    ]);
  }

  function footer(text) {
    return el('div', { class: 'iv-mk-footer' }, [
      el('span', null, ['ABC Infoskjerm']),
      el('div', { class: 'iv-ticker' }, [el('span', null, [text])]),
      el('span', null, ['LIVE']),
    ]);
  }

  // ── WELCOME ────────────────────────────────────────────────
  function buildWelcome(time) {
    const visitors = [
      { t: '10:00', n: 'Maren Berg — Laerdal Medical' },
      { t: '11:30', n: 'Even Solheim — Brødrene Dahl' },
      { t: '13:00', n: 'Riksantikvaren · befaring' },
    ];
    const body = el('div', { class: 'iv-body' }, [
      el('div', { class: 'iv-hi' }, ['Velkommen til ABC Teknikk']),
      el('h1', { html: 'Hyggelig at du er <em>innom</em> hos oss i&nbsp;dag.' }),
      el('p', null, ['Ta deg gjerne en kaffe i kantinen — vi er straks med deg.']),
      el('div', { class: 'iv-visitors' },
        visitors.map(function (v) {
          return el('div', { class: 'iv-vrow' }, [
            el('div', { class: 'iv-t' }, [v.t]),
            el('div', { class: 'iv-n' }, [v.n]),
          ]);
        })
      ),
    ]);
    return el('div', { class: 'iv-mockup iv-mk-welcome' }, [
      header('Resepsjon · Velkommen', time),
      body,
      footer('Trådløst nett: ABC-Gjest  ·  Passord deles ved innsjekk  ·  Velkommen!'),
    ]);
  }

  // ── CALENDAR ───────────────────────────────────────────────
  function buildCalendar(time, date) {
    const events = [
      { t: '09:00', label: 'Standup — utvikling', sub: 'Møterom A · 8 deltakere', cls: '' },
      { t: '10:30', label: 'Kundepresentasjon — Brødrene Dahl', sub: 'Auditorium · 22 deltakere', cls: 'iv-now' },
      { t: '13:00', label: 'AV-prosjektgjennomgang', sub: 'Møterom B · 6 deltakere', cls: '' },
      { t: '14:30', label: 'Onboarding — nye ansatte', sub: 'Kantine · 12 deltakere', cls: 'iv-alt' },
      { t: '16:00', label: 'Strategi Q3 — ledergruppe', sub: 'Møterom A · 9 deltakere', cls: '' },
    ];
    const left = el('div', { class: 'iv-left' }, [
      el('div', { class: 'iv-date' }, [date.getDate() + '.']),
      el('div', { class: 'iv-month' }, [fmtMonthYear(date)]),
      el('div', { class: 'iv-now-label' }, ['Nå pågår']),
    ]);
    const right = el('div', { class: 'iv-right' },
      events.map(function (e) {
        const lbl = el('div', { class: 'iv-label' }, [e.label]);
        lbl.appendChild(el('small', null, [e.sub]));
        return el('div', { class: 'iv-ev ' + e.cls }, [
          el('div', { class: 'iv-t' }, [e.t]),
          el('div', { class: 'iv-bar' }),
          lbl,
        ]);
      })
    );
    return el('div', { class: 'iv-mockup iv-mk-cal' }, [
      header('Dagens program', time),
      el('div', { class: 'iv-body' }, [left, right]),
      footer('Møterom oppdateres automatisk fra Microsoft 365  ·  Logg inn for å booke  ·  Sentralbord 66 82 39 00'),
    ]);
  }

  // ── MENU ───────────────────────────────────────────────────
  function buildMenu(time) {
    const dishes = [
      { name: 'Kremet kyllinggryte', desc: 'Med ris, friske urter og ovnsbakte rotgrønnsaker', tag: 'Kjøtt', veg: false },
      { name: 'Bakt torsk i tomatsaus', desc: 'Servert med pasta og parmesan', tag: 'Fisk', veg: false },
      { name: 'Linsegryte med spinat', desc: 'Indisk-inspirert med basmati og naan', tag: 'Veg', veg: true },
      { name: 'Dagens suppe', desc: 'Gulrot- og ingefærsuppe med hvitt brød', tag: 'Veg', veg: true },
    ];
    const body = el('div', { class: 'iv-body' }, [
      el('div', { class: 'iv-heading' }, [
        el('h3', null, ['Dagens meny']),
        el('div', { class: 'iv-day-label' }, ['Tirsdag · 11:00 – 13:30']),
      ]),
    ].concat(
      dishes.map(function (d) {
        const inner = el('div', null, [el('div', { class: 'iv-name' }, [d.name])]);
        inner.appendChild(el('div', { class: 'iv-desc' }, [d.desc]));
        return el('div', { class: 'iv-dish' }, [
          inner,
          el('div', { class: 'iv-tag' + (d.veg ? ' iv-veg' : '') }, [d.tag]),
        ]);
      })
    ));
    return el('div', { class: 'iv-mockup iv-mk-menu' }, [
      header('Kantinen · Lunsj', time),
      body,
      footer('Allergener merkes ved disken  ·  Kaffe og frukt tilgjengelig hele dagen  ·  Spørsmål? Snakk med Kari på kjøkkenet'),
    ]);
  }

  // ── WEATHER ────────────────────────────────────────────────
  function buildWeather(time) {
    const days = [
      { d: 'Tir', t: '−1°', ic: '❄' },
      { d: 'Ons', t: '+2°', ic: '☁' },
      { d: 'Tor', t: '+4°', ic: '☂' },
      { d: 'Fre', t: '+1°', ic: '☀' },
    ];
    const now = el('div', { class: 'iv-now' }, [
      el('div', { class: 'iv-city' }, ['Akkurat nå']),
      el('div', { class: 'iv-temp' }, ['−2°']),
      el('div', { class: 'iv-desc' }, ['Lett snøvær, vind fra nord 4 m/s']),
      el('div', { class: 'iv-meta' }, [
        el('div', { html: 'Føles som <b>−6°</b>' }),
        el('div', { html: 'Soloppgang <b>07:48</b>' }),
      ]),
    ]);
    const forecast = el('div', { class: 'iv-forecast' },
      days.map(function (x) {
        return el('div', { class: 'iv-day' }, [
          el('div', { class: 'iv-d' }, [x.d]),
          el('div', { class: 'iv-ic' }, [x.ic]),
          el('div', { class: 'iv-t' }, [x.t]),
        ]);
      })
    );
    return el('div', { class: 'iv-mockup iv-mk-weather' }, [
      header('Vær · Trollåsen', time),
      el('div', { class: 'iv-body' }, [now, forecast]),
      footer('Værvarsel oppdateres hvert 10. minutt fra met.no  ·  Kollektivtrafikk normal  ·  E18 åpen begge retninger'),
    ]);
  }

  // ── NEWS ───────────────────────────────────────────────────
  function buildNews(time) {
    const items = [
      { cat: 'HR', title: 'Sommerferieskjema sendt ut' },
      { cat: 'IT', title: 'Wi-Fi oppgraderes torsdag 03:00' },
      { cat: 'Velferd', title: 'Påmelding til høstturen — 14. mai' },
      { cat: 'Salg', title: 'Q1 over budsjett · 112 %' },
    ];
    const feature = el('div', { class: 'iv-feature' }, [
      el('div', { class: 'iv-cat' }, ['Hovedsak']),
      el('h2', null, ['Nytt møterom åpnet i 4. etasje — booking åpen fra mandag']),
      el('div', { class: 'iv-sub' }, ['Plass til 12 personer · videokonferanseutstyr · skjerm-deling']),
    ]);
    const list = el('div', { class: 'iv-list' },
      items.map(function (it) {
        return el('div', { class: 'iv-item' }, [
          el('div', { class: 'iv-cat' }, [it.cat]),
          el('h4', null, [it.title]),
        ]);
      })
    );
    return el('div', { class: 'iv-mockup iv-mk-news' }, [
      header('Internt · Nyheter', time),
      el('div', { class: 'iv-body' }, [feature, list]),
      footer('Intranett-feed oppdaterer automatisk  ·  post@abcteknikk.no for å sende inn nyhetssaker'),
    ]);
  }

  const SCREENS = [
    { key: 'welcome',  label: 'Resepsjon', build: buildWelcome },
    { key: 'calendar', label: 'Kalender',  build: buildCalendar },
    { key: 'menu',     label: 'Kantine',   build: buildMenu },
    { key: 'weather',  label: 'Vær',       build: buildWeather },
    { key: 'news',     label: 'Nyheter',   build: buildNews },
  ];

  function init(root) {
    const inner = root.querySelector('.iv-screen-inner');
    const pagerHost = root.querySelector('[data-iv-pager]');
    if (!inner) return;

    const speed = parseInt(root.getAttribute('data-iv-speed') || '4500', 10);
    let i = 0;
    let date = new Date();

    function render() {
      date = new Date();
      const time = fmtTime(date);
      const node = SCREENS[i].build(time, date);
      node.classList.add('iv-active');
      inner.innerHTML = '';
      inner.appendChild(node);
      if (pagerHost) {
        Array.prototype.forEach.call(pagerHost.querySelectorAll('button'), function (b, idx) {
          b.classList.toggle('iv-on', idx === i);
        });
      }
    }

    if (pagerHost) {
      pagerHost.innerHTML = '';
      SCREENS.forEach(function (s, idx) {
        const b = el('button', { type: 'button', 'aria-label': s.label });
        b.addEventListener('click', function () { i = idx; render(); });
        pagerHost.appendChild(b);
      });
    }

    render();

    if (speed > 0) {
      setInterval(function () {
        i = (i + 1) % SCREENS.length;
        render();
      }, speed);
    }
    // refresh clock every 30s even between transitions
    setInterval(render, 30000);
  }

  function bootstrap() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-iv-mockup]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
